module.exports = __webpack_public_path__ + "static/media/red-dollar.2c068ea8.svg";